import { param } from "jquery";

export class DistribuidorApi {
    path = '/adm/distribuidores';

    async list(filters = null) {
        try {
            const response = await axios.get(`${this.path}/list`, {
                params: filters,
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching distribuidores list:', error);
            throw error;
        }
    }
    
    async show(id) {
        try {
            const response = await axios.get(`${this.path}/${id}/payload`);

            return response.data;
        } catch (error) {
            console.error('Error fetching distribuidor:', error);
            throw error;
        }
    }

    async produtos(params) {
        try {
            const response = await axios.get('/distribuidor/produtos/list', { params });

            return response.data;
        } catch (error) {
            console.error('Error fetching products:', error);
            throw error;
        }
    }

    async pedidoMinimo() {
        try {
            const response = await axios.get('/distribuidor/pedidominimo');

            return response.data;
        } catch (error) {
            console.error('Error fetching products:', error);
            throw error;
        }
    }

    async banners(filters) {
        try {
            const response = await axios.get('/adm/banner/listar/distribuidor', {
                param: filters,
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching banners:', error);
            throw error;
        }
    }

    async materialDownload(filters) {
        try {
            const response = await axios.get('/adm/material-download/listar/distribuidor', {
                param: filters,
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching materials Download:', error);
            throw error;
        }
    }

    async changePassword(data) {
        try {
            const response = await axios.post(`${this.path}/reset-password`, data);

            return response.data;
        } catch (error) {
            console.error('Error change distributor password:', error);
            throw error;
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/api/DistribuidorApi.js